import { render, staticRenderFns } from "./TreeResult.vue?vue&type=template&id=0963d1fb&scoped=true&"
import script from "./TreeResult.vue?vue&type=script&lang=js&"
export * from "./TreeResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0963d1fb",
  null
  
)

export default component.exports